module.exports = __webpack_public_path__ + "img/TZ.90f03754.svg";